export const INITIAL_STATE = {
  letters: [],
  selectedLetters: [],
  validWords: [],
  validWordsClone: [],
  points: [],
  hintWord: '',
  revealedHints: {},
  foundWords: 0,
  currentWord: '',
  connectorPath: '',
  connectedPath: '',
  successMessage: '',
  coins: 0,
  level: 1,
  showConfetti: false,
};

export function gameReducer(state, action) {
  switch (action.type) {
    case 'SET_GAME':
      return {
        ...state,
        letters: action.payload.letters,
        validWords: action.payload.validWords,
        validWordsClone: action.payload.validWords,
        points: action.payload.points,
        currentWord: '',
        selectedLetters: [],
        connectedPath: '',
        connectorPath: '',
        foundWords: 0,
        hintWord: '',
        revealedHints: {},
      };

    case 'SELECT_LETTER':
      if (state.selectedLetters.includes(action.payload.id)) {
        return state;
      }

      return {
        ...state,
        selectedLetters: [
          ...state.selectedLetters,
          action.payload.id,
        ],
        currentWord:
          state.currentWord + action.payload.letter,
      };

    case 'UPDATE_PATH':
      return {
        ...state,
        connectedPath: action.payload.connected,
        connectorPath: action.payload.connector,
      };

    case 'RESET_SELECTION':
      return {
        ...state,
        currentWord: '',
        selectedLetters: [],
        connectedPath: '',
        connectorPath: '',
      };

    case 'VALID_WORD':
      return {
        ...state,
        validWords: state.validWords.filter(
          (w) => w !== state.currentWord
        ),
        foundWords: state.foundWords + 1,
        coins:
          state.coins + state.currentWord.length,
        showConfetti: false,
      };

    case 'SHOW_CONFETTI':
      return {
        ...state,
        showConfetti: true,
      };

    case 'HIDE_CONFETTI':
      return {
        ...state,
        showConfetti: false,
      };

    case 'LEVEL_UP':

      return {

        ...state,

        level: state.level + 1,

        coins: state.coins + 100,

      };

    case 'SHUFFLE':
      return {
        ...state,
        letters: action.payload,
      };

    case "HINT_USED":
      return {
        ...state,

        hintWord: action.payload.word,

        revealedHints: {
          ...state.revealedHints,
          [action.payload.word]: [
            ...(state.revealedHints[action.payload.word] || []),
            action.payload.index,
          ],
        },

        coins: Math.max(0, state.coins - 5),
      };

    case "SET_SUCCESS_MESSAGE":
      return {
        ...state,
        successMessage: action.payload,
      };

    case "CLEAR_SUCCESS_MESSAGE":
      return {
        ...state,
        successMessage: "",
      };

    default:
      return state;
  }
}